import React, { useContext } from "react";
import { popupcontext } from "../../../../context/Popupscontext";
import { useMap } from "react-leaflet";
import trans from "../../../../utils";

export default function PlayBackFunctionsSettings({
	settings,
	setSettings,
	mainhistorypositions,
}) {
	let { posIndex } = useContext(popupcontext);
	const map = useMap();
	const centerVehicle = () => {
		map.setView([
			mainhistorypositions[posIndex].latitude,
			mainhistorypositions[posIndex].longitude,
		]);
	};
	const lang = localStorage.getItem("lang") || "en";
	return (
		<div
			className={`history-playback-functions-settings ${
				lang === "en"
					? "history-playback-functions-settings-ltr"
					: "history-playback-functions-settings-rtl"
			}`}
		>
			<div className="mt-2">
				<div className="d-flex align-items-center">
					<div className="mx-2 mb-2">
						<input
							type="checkbox"
							value="ON"
							onChange={() => {
								setSettings({
									parkingPeriods: !settings.parkingPeriods,
									idlePeriods: settings.idlePeriods,
									centerTracker: settings.centerTracker,
									mapPoints: settings.mapPoints,
								});
							}}
							name=""
							id=""
							className="cursor"
						/>
					</div>
					<div className="y-25">{trans("Parking Periods")}</div>
				</div>
				<div className="d-flex align-items-center">
					<div className="mx-2 mb-2">
						<input
							type="checkbox"
							value="ON"
							onChange={() => {
								setSettings({
									parkingPeriods: settings.parkingPeriods,
									idlePeriods: !settings.idlePeriods,
									centerTracker: settings.centerTracker,
									mapPoints: settings.mapPoints,
								});
							}}
							name=""
							id=""
							className="cursor"
						/>
					</div>
					<div className="y-25">{trans("Idle Periods")}</div>
				</div>
				<div className="d-flex align-items-center">
					<div className="mx-2 mb-2">
						<input
							type="checkbox"
							value="ON"
							onChange={() => {
								setSettings({
									parkingPeriods: settings.parkingPeriods,
									idlePeriods: settings.idlePeriods,
									centerTracker: !settings.centerTracker,
									mapPoints: settings.mapPoints,
								});
								centerVehicle();
							}}
							name=""
							id=""
							className="cursor"
						/>
					</div>
					<div className="y-25">{trans("Center Tracker")}</div>
				</div>
				{/* <div className="d-flex align-items-center">
					<div className="mx-2 mb-2">
						<input
							type="checkbox"
							value="ON"
							onChange={() => {
								setSettings({
									parkingPeriods: settings.parkingPeriods,
									idlePeriods: settings.idlePeriods,
									centerTracker: settings.centerTracker,
									mapPoints: !settings.mapPoints

								});
								centerVehicle();
							}}
							name=""
							id=""
							className="cursor"
						/>
					</div>
					<div className="y-25">{trans("Vehicle Movement")}</div>
				</div> */}
			</div>
		</div>
	);
}
